import { render, staticRenderFns } from "./BarProportion.vue?vue&type=template&id=3c1e26b7"
import script from "./BarProportion.vue?vue&type=script&lang=js"
export * from "./BarProportion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports